import { render, staticRenderFns } from "./TranslationTags.vue?vue&type=template&id=7fad1572"
import script from "./TranslationTags.vue?vue&type=script&lang=js"
export * from "./TranslationTags.vue?vue&type=script&lang=js"
import style0 from "./TranslationTags.vue?vue&type=style&index=0&id=7fad1572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports